import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import Subheader from 'material-ui/Subheader';
import makeSelectable, { wrapState } from '../../helpers/makeMultiSelectList';
import TextField from 'material-ui/TextField';
import List from 'material-ui/List/List';
import ListItem from 'material-ui/List/ListItem';
import Avatar from 'material-ui/Avatar';
import { Spinner, PageHeader, CheckboxList } from 'components';
import RaisedButton from 'material-ui/RaisedButton';
var SelectableList = makeSelectable(List);
SelectableList = wrapState(SelectableList);
export default function UserEmailSelector(_ref) {
  var notifiableContacts = _ref.notifiableContacts,
      manualEmailValue = _ref.manualEmailValue,
      handleManualEmailValueChanged = _ref.handleManualEmailValueChanged,
      handleAddManualEmail = _ref.handleAddManualEmail,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      isSMB = _ref.isSMB;
  return /*#__PURE__*/React.createElement("span", null, !!notifiableContacts && Object.keys(notifiableContacts).length > 0 && /*#__PURE__*/React.createElement(SelectableList, {
    defaultValue: defaultValue,
    multiple: true,
    onChange: onChange
  }, Object.keys(notifiableContacts).map(function (key) {
    return [Object.keys(notifiableContacts).length > 1 ? /*#__PURE__*/React.createElement(Subheader, {
      key: key
    }, key) : null].concat(_toConsumableArray(notifiableContacts[key].map(function (tm, index) {
      return /*#__PURE__*/React.createElement(ListItem, {
        style: {
          MozUserSelect: 'none',
          WebkitUserSelect: 'none',
          msUserSelect: 'none'
        },
        key: "".concat(key, "_user_").concat(index),
        onClick: function onClick() {},
        value: "".concat(tm.email),
        primaryText: tm.name ? tm.name : tm.email,
        secondaryText: isSMB ? '' : tm.name ? tm.email : '',
        leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
          src: tm.picture
        }, !tm.picture ? tm.name ? "".concat(tm.name).split(' ').map(function (s) {
          return s[0];
        }).join('').toUpperCase() : "".concat(tm.email).split(' ').map(function (s) {
          return s[0];
        }).join('').toUpperCase() : null)
      });
    }))).filter(function (c) {
      return c;
    });
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '24px 0',
      color: '#333333'
    }
  }, "Don't see someone on this list? Enter their email below."), /*#__PURE__*/React.createElement(TextField, {
    placeholder: "someone@example.com",
    id: "manuallyEnteredEmail",
    value: manualEmailValue,
    onChange: handleManualEmailValueChanged
  }), /*#__PURE__*/React.createElement(RaisedButton, {
    primary: true,
    label: "Add Email",
    style: {
      marginLeft: 24
    },
    onClick: handleAddManualEmail
  }));
}